import React, { useState } from "react";
import HideImageIcon from "@mui/icons-material/HideImage";
import {
  ProductWrapper,
  ProductLeft,
  ProductRight,
  ProductImage,
  DotWrapper,
  Dots,
  ProductTitle,
  ProductText,
  BottomBox,
  ProductInput,
  CreamText,
  FieldWrapper,
  ButtonWrapper,
  QuantityButton,
  RecommendedProducts
} from "./styles";
import { ProductCart } from "../../Products/Product/styles";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { privateAPI } from "../../../utils/api";
import { getCookie } from '../../../utils/cookie';

const ProductFullDescription = ({ ...props }) => {
  let [productQuantity, setProductQuantity] = useState(1);
  const [userID] = useState(getCookie('userId'));
  const [image, setImage] = useState(0);
  const { t, i18n } = useTranslation();
  var language = i18n.language;

  const setProductInCart = async () => {
    const response = await privateAPI.get(`/auth/bacchus/client/cart/${userID}`);
    const isProductInCart = response.data.cartProducts.some(item => item.id === props.product.id)

    if(isProductInCart) return toast.warning('Product is already in cart');

    try{
        const id = getCookie('userId');
        const productDTO = {
            productId: props.product.id,
            quantity: productQuantity,
            userId: id
        }
        await privateAPI.post(`/auth/bacchus/client/cart`, productDTO);
        toast.success('In cart!')
    } catch (error){
        if(error.request && error.request.status === 500) return toast.error('Internal server error')
    }
  }

  return (
    <React.Fragment>
      <ProductWrapper>
        <ProductLeft>
          {props.product.image ? (
            <ProductImage
              src={props.product.image[image]}
              alt={props.product.name}
            />
          ) : (
            <HideImageIcon
              style={{
                height: "50px",
                width: "50px",
                color: "#001753 !important",
              }}
            />
          )}
          {props.product.image && props.product.image.length > 1 && (
            <DotWrapper>
              {props.product.image.map((product, index) => (
                <Dots
                  key={product}
                  isActive={image === index}
                  onClick={() => setImage(index)}
                />
              ))}
            </DotWrapper>
          )}
        </ProductLeft>
        <ProductRight>
          <ProductTitle>
            {language === "en"
              ? props.product.name
              : language === "fr"
              ? props.product.name_fr
              : language === "de"
              ? props.product.name_de
              : language === "it"
              ? props.product.name_it
              : props.product.name}
          </ProductTitle>
          {props.product.alcoholPercentage &&
            <ProductText>
              {t('alcohol')}: <CreamText>{props.product.alcoholPercentage}% vol</CreamText>
            </ProductText>
          }
          <ProductText>
            {t('net')}: <CreamText>{props.product.liter}l</CreamText>
          </ProductText>
          <ProductText>
            {t('onStock')}: <CreamText count={props.product.stock}>{props.product.stock < 10 ? 'Only: ' : ''}{props.product.stock}</CreamText>
          </ProductText>
          <br />
          <h3 style={{ marginBottom: "10px" }}>{t('description')}:</h3>
          <ProductText
            style={{ marginBottom: "30px" }}
            dangerouslySetInnerHTML={{
             __html: language === "en"
                ? props.product.description
                : language === "fr"
                ? props.product.description_fr
                : language === "de"
                ? props.product.description_de
                : language === "it"
                ? props.product.description_it
                : props.product.description
                }}
          />
          <BottomBox>
            <div>
              <p>{t('price')}: <strong>{props.product?.price?.toFixed(2)} CHF</strong></p>
              <p>inkl. MwSt.</p>
            </div>
            <FieldWrapper>
              <ProductInput>{productQuantity}</ProductInput>
              <ButtonWrapper>
                <QuantityButton
                  onClick={() => setProductQuantity(++productQuantity)}
                  disabled={productQuantity >= props.product.stock}
                  plus
                >
                  +
                </QuantityButton>
                <QuantityButton
                  onClick={() => setProductQuantity(--productQuantity)}
                  minus
                  disabled={productQuantity === 0}
                >
                  -
                </QuantityButton>
              </ButtonWrapper>
            </FieldWrapper>
            <FieldWrapper>
              <ProductCart single onClick={productQuantity <= props.product.stock ? () => setProductInCart() : () => toast.info('Over stock')}/>
            </FieldWrapper>
          </BottomBox>
        </ProductRight>
      </ProductWrapper>
      <RecommendedProducts>{t('recommended')} <CreamText>{t('products')}</CreamText></RecommendedProducts>
    </React.Fragment>
  );
};

export default ProductFullDescription;
